// pages/Contacts.jsx
// pages/Contacts.jsx
import React from 'react';
import './Contacts.css';

const Contacts = () => {
    return (
        <div className="contacts-page">
            <h1 className="contacts-title">Контакты</h1>
            
            <div className="contacts-container">
                {/* Блок с картой */}
                <div className="contacts-map">
                    <iframe 
                        src="https://yandex.ru/map-widget/v1/?ll=37.540968%2C55.648562&mode=whatshere&whatshere%5Bpoint%5D=37.540856%2C55.648214&whatshere%5Bzoom%5D=17&z=16.16"
                        width="100%" 
                        height="100%" 
                        style={{ border: 0, minHeight: '400px' }}
                        allowFullScreen
                        loading="lazy"
                        title="Карта офиса Эскалайн"
                    />
                </div>

                {/* Блок с контактной информацией */}
                <div className="contacts-info">
                    <div className="info-card">
                        <div className="info-item">
                            <div className="info-icon-wrapper">
                                <span className="info-icon">📍</span>
                            </div>
                            <div className="info-text">
                                <h3>Адрес офиса</h3>
                                <p>Москва, Россия<br />ул. Бутлерова, д. 17Б, помещ. 60/11/2</p>
                            </div>
                        </div>

                        <div className="info-item">
                            <div className="info-icon-wrapper">
                                <span className="info-icon">🗄️</span>
                            </div>
                            <div className="info-text">
                                <h3>Адрес склада</h3>
                                <p>Москва, Россия<br />Новомосковский административный округ, район Коммунарка, деревня Николо-Хованское, 9/1А</p>
                            </div>
                        </div>

                        <div className="info-item">
                            <div className="info-icon-wrapper">
                                <span className="info-icon">📞</span>
                            </div>
                            <div className="info-text">
                                <h3>Телефон</h3>
                                <a href="tel:+74996820168" className="info-link">+7 (499) 682-01-68</a>
                            </div>
                        </div>

                        <div className="info-item">
                            <div className="info-icon-wrapper">
                                <span className="info-icon">✉️</span>
                            </div>
                            <div className="info-text">
                                <h3>E-mail</h3>
                                <a href="mailto:escaline.msk@gmail.com" className="info-link">escaline.msk@gmail.com</a>
                            </div>
                        </div>

                        
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Contacts;